import { cn } from '../../lib/utils';

export default function MetricBar({ label, value, max = 100, tone = 'neutral' }) {
    const pct = Math.max(0, Math.min(100, (value / max) * 100));
    const color =
        tone === 'brand' ? '#2F6B47'
        : tone === 'up' ? '#0B8A3E'
        : tone === 'down' ? '#C3341C'
        : '#0A0A0A';
    return (
        <div className="flex items-center gap-4">
            <div className="w-32 text-[12px] uppercase tracking-[0.14em] text-neutral-500">{label}</div>
            <div className="flex-1 h-[6px] bg-neutral-100 relative overflow-hidden">
                <div className="absolute inset-y-0 left-0" style={{ width: `${pct}%`, background: color }} />
            </div>
            <div className="w-10 text-right font-mono-data text-[13px] tabular">{Math.round(value)}</div>
        </div>
    );
}
